/**
 * @date 03/14/2017
 * @copyright 2016 Empower Retirement
 * @description
 *
 * Container for all things contextually bound to transaction messages.
 *
 */
import "angular";
import TransactionMessagesController from "./TransactionMessagesController";
import TransactionMessagesDirective from "./TransactionMessagesDirective";
import TransactionMessagesFactory from "./TransactionMessagesFactory";
import TransactionMessagesService from "./TransactionMessagesService";

var moduleName = "TransactionMessagesModule";
var moduleDependencies = [];

const TransactionMessagesModule = angular
    .module(moduleName, moduleDependencies)
    .directive("transactionMessages", TransactionMessagesDirective)
    .controller("transactionMessagesController", TransactionMessagesController)
    .service("transactionMessagesService", TransactionMessagesService)
    .factory("transactionMessagesFactory", TransactionMessagesFactory);

export default TransactionMessagesModule;
